import { useEffect, useRef } from 'react'

/**
 * Screen Wake Lock — 화면 자동 꺼짐 방지
 * 집중 모드(포모도로) 실행 중 화면 유지
 */
export function useWakeLock(enabled: boolean) {
  const lockRef = useRef<WakeLockSentinel | null>(null)

  useEffect(() => {
    if (!enabled || !('wakeLock' in navigator)) return

    let released = false

    navigator.wakeLock.request('screen').then((lock) => {
      if (released) {
        lock.release()
        return
      }
      lockRef.current = lock
      lock.addEventListener('release', () => {
        lockRef.current = null
      })
    }).catch(() => {
      // Wake Lock 미지원 또는 권한 거부
    })

    return () => {
      released = true
      lockRef.current?.release()
      lockRef.current = null
    }
  }, [enabled])
}
